/**
 * Cookies
 * A complete cookies reader/writer framework with full unicode support by Mozilla:
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
 */

/**
 * * Class Cookies that handles base functionality for handling cookies.
 * @class
 */
class Cookies {

    /**
     * @param {string} sKey - key
     * @returns {*} - decodeURIComponent
     */
    getItem(sKey) {
        if (!sKey) {
            return null;
        }

        return decodeURIComponent(document.cookie.replace(new RegExp(`(?:(?:^|.*;)\\s* ${encodeURIComponent(sKey).replace(/[\\-\\.\\+\\*]/g, '\\$&')} \\s*\\=\\s*([^;]*).*$)|^.*$`), '$1')) || null;
    }

    /**
     * @param {string} sKey - key
     * @param {string} sValue - value
     * @param {string} vEnd - end
     * @param {string} sPath - path
     * @param {string} sDomain - domain
     * @param {string} bSecure - secure
     * @returns {boolean} - boolean
     */
    setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        sDomain ? `; domain=${sDomain}` : '';
        sPath ? `; path=${sPath}` : '';
        bSecure ? '; secure' : '';
        let sExpires = '';
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${vEnd}`;
                    break;
                case String:
                    sExpires = `; expires=${vEnd}`;
                    break;
                case Date:
                    sExpires = `; expires= ${vEnd.toUTCString()}`;
                    break;
            }
        }
        // document.cookie = encodeURIComponent(sKey) + '=' + sValue + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
        document.cookie = `${encodeURIComponent(sKey)} = ${sValue} ${sExpires} ${sDomain} ${sPath} ${bSecure}`;

        return true;
    }

    /**
     *
     * @param {string} sKey - key
     * @param {string} sPath - path
     * @param {string} sDomain - domain
     * @returns {boolean} - boolean
     */
    removeItem(sKey, sPath, sDomain) {
        sDomain ? `; domain=${sDomain}` : '';
        sPath ? `; path=${sPath}` : '';

        if (!this.hasItem(sKey)) {
            return false;
        }
        // document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '');
        document.cookie = `${encodeURIComponent(sKey)} =; expires=Thu, 01 Jan 1970 00:00:00 GMT ${sDomain} ${sPath}`;
        
        return true;
    }

    /**
     *
     * @param {string} sKey - key
     * @returns {boolean} - boolean
     */
    hasItem(sKey) {
        if (!sKey) {
            return false;
        }
        
        // return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
        sKey = encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&');

        return new RegExp(`(?:^|;\\s*)${sKey}\\s*\\=`).test(document.cookie);
    }

    /**
     * @returns {Array} - Array
     */
    keys() {
        let aKeys = document.cookie.replace(/((?:^|\s*;)[^\\=]+)(?=;|$)|^\s*|\s*(?:\\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\\=[^;]*)?;\s*/);
        for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }

        return aKeys;
    }
}

export default new Cookies();
